export function getSvgPointFromClient(mySvg, clientX, clientY) {
  const point = mySvg.createSVGPoint()
  point.x = clientX
  point.y = clientY
  return point.matrixTransform(mySvg.getScreenCTM().inverse())
}

export function ensureSvgGlowFilter(svg, documentRef, filterId) {
  let defs = svg.select('defs')
  if (!defs) {
    defs = svg.paper.el('defs')
    svg.append(defs)
  }
  const existingGlow = defs.select(`#${filterId}`)
  if (existingGlow) return filterId

  const filter = documentRef.createElementNS(
    'http://www.w3.org/2000/svg',
    'filter'
  )
  filter.setAttribute('id', filterId)
  filter.setAttribute('x', '-40%')
  filter.setAttribute('y', '-40%')
  filter.setAttribute('width', '180%')
  filter.setAttribute('height', '180%')
  const feGaussian = documentRef.createElementNS(
    'http://www.w3.org/2000/svg',
    'feGaussianBlur'
  )
  feGaussian.setAttribute('in', 'SourceGraphic')
  feGaussian.setAttribute('stdDeviation', '4')
  feGaussian.setAttribute('result', 'blur')
  filter.appendChild(feGaussian)
  const feMerge = documentRef.createElementNS(
    'http://www.w3.org/2000/svg',
    'feMerge'
  )
  const feMergeNode1 = documentRef.createElementNS(
    'http://www.w3.org/2000/svg',
    'feMergeNode'
  )
  feMergeNode1.setAttribute('in', 'blur')
  const feMergeNode2 = documentRef.createElementNS(
    'http://www.w3.org/2000/svg',
    'feMergeNode'
  )
  feMergeNode2.setAttribute('in', 'SourceGraphic')
  feMerge.appendChild(feMergeNode1)
  feMerge.appendChild(feMergeNode2)
  filter.appendChild(feMerge)
  defs.node.appendChild(filter)
  return filterId
}

export function removeSvgLikeElements(elements = []) {
  elements.forEach(element => {
    if (!element) return
    if (element.remove && typeof element.remove === 'function') {
      element.remove()
      return
    }
    if (element.parentNode) element.parentNode.removeChild(element)
  })
}
